import React from 'react';

const DownloadJsonIcon = ({ width = 24, height = 24, color = 'black' }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
            fill="#f0f0f0"
            stroke={color}
            strokeWidth="1"
        />
        <polyline
            points="14 2 14 8 20 8"
            fill="none"
            stroke={color}
            strokeWidth="1"
        />
        <path
            d="M12 10v5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <polyline
            points="10 13 12 15 14 13"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <text
            x="12"
            y="20"
            textAnchor="middle"
            fill={color}
            fontSize="3"
            fontFamily="Arial, sans-serif"
        >
            JSON
        </text>
    </svg>
);

export default DownloadJsonIcon;
